import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { RecruitmentDashboardScreen } from '@/features/recruitment-dashboard/dashboard-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the per-opening dashboard, at `/recruitment/openings/$openingId`.
 *
 * Guarded on `recruitment_opening.view` — the dashboard endpoint authorises
 * on that key server-side; this only keeps an ungranted user out of a screen
 * they cannot use.
 *
 * The back button is wired to the board here, keeping the router out of the
 * feature component (which stays testable in isolation).
 *
 * Per the route-shell rule, this file is a route definition, a guard and a
 * render. The screen lives in `src/features/recruitment-dashboard/`.
 */
export const Route = createFileRoute('/_authenticated/recruitment/openings/$openingId')({
  validateSearch: z.object({ showHidden: z.boolean().optional() }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'recruitment_opening.view')) {
      throw redirect({ to: '/recruitment' })
    }
  },
  component: RecruitmentDashboardRoute,
})

function RecruitmentDashboardRoute() {
  const { openingId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <RecruitmentDashboardScreen
      openingId={openingId}
      onBack={() => void navigate({ to: '/recruitment' })}
    />
  )
}
